(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleepdoctor-header-backup"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleepdoctor-header-offcanvas"] && !Shopify.designMode) return;
  try {
    
  class HeaderOffcanvasMenu {
    constructor() {
      this.triggers = document.querySelectorAll('.header-offcanvas-trigger');
      this.menus = document.querySelectorAll('.header-offcanvas-menu');
      this.overlays = document.querySelectorAll('.header-offcanvas-overlay');
      this.submenuTriggers = document.querySelectorAll('.header-offcanvas-menu__submenu-trigger');
      this.submenus = document.querySelectorAll('.header-offcanvas-submenu');
      this.activeMenu = null;
      this.activeSubmenu = null;

      this.init();
    }

    init() {
      // Track hover timers for delayed closing
      this.hoverCloseTimer = null;
      this.isDesktop = window.matchMedia('(min-width: 990px)').matches;

      // Add click handlers to menu triggers
      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          const menuHandle = trigger.dataset.menuHandle;
          this.openMenu(menuHandle);
        });
      });

      // Add close button handlers
      this.menus.forEach((menu) => {
        const closeBtn = menu.querySelector('.header-offcanvas-menu__close');
        if (closeBtn) {
          closeBtn.addEventListener('click', () => {
            this.closeMenu();
          });
        }
      });

      // Add submenu trigger handlers (click for mobile, hover for desktop)
      this.submenuTriggers.forEach((trigger) => {
        // Click handler for mobile
        trigger.addEventListener('click', (e) => {
          // On desktop, prevent click from toggling if hover is enabled
          if (this.isDesktop) {
            e.preventDefault();
            // Allow click to navigate if submenu is already open
            const submenuHandle = trigger.dataset.submenuHandle;
            if (this.activeSubmenu === submenuHandle) {
              // Could optionally navigate to a parent link here if needed
              return;
            }
          } else {
            // Mobile behavior - toggle on click
            e.preventDefault();
            const submenuHandle = trigger.dataset.submenuHandle;
            const parentMenu = trigger.dataset.parentMenu;
            this.openSubmenu(submenuHandle, parentMenu);
          }
        });

        // Hover handlers for desktop only
        if (this.isDesktop) {
          // Mouse enter - open submenu
          trigger.addEventListener('mouseenter', () => {
            clearTimeout(this.hoverCloseTimer);
            const submenuHandle = trigger.dataset.submenuHandle;
            const parentMenu = trigger.dataset.parentMenu;
            this.openSubmenu(submenuHandle, parentMenu);
          });

          // Mouse leave - close submenu with delay
          trigger.addEventListener('mouseleave', (e) => {
            const submenuHandle = trigger.dataset.submenuHandle;
            const submenu = document.querySelector(`.header-offcanvas-submenu[data-submenu-handle="${submenuHandle}"]`);

            // Check if mouse is moving to the submenu itself
            const relatedTarget = e.relatedTarget;
            if (relatedTarget && submenu && submenu.contains(relatedTarget)) {
              return; // Don't close if moving to submenu
            }

            // Close with delay to allow moving to submenu
            this.hoverCloseTimer = setTimeout(() => {
              if (this.activeSubmenu === submenuHandle) {
                this.closeSubmenu();
              }
            }, 300); // 300ms delay before closing
          });
        }
      });

      // Add hover handlers for submenus themselves (desktop only)
      if (this.isDesktop) {
        this.submenus.forEach((submenu) => {
          // Keep submenu open when hovering over it
          submenu.addEventListener('mouseenter', () => {
            clearTimeout(this.hoverCloseTimer);
          });

          // Close when leaving submenu
          submenu.addEventListener('mouseleave', (e) => {
            const relatedTarget = e.relatedTarget;
            const submenuHandle = submenu.dataset.submenuHandle;

            // Find the trigger button for this submenu
            const trigger = document.querySelector(
              `.header-offcanvas-menu__submenu-trigger[data-submenu-handle="${submenuHandle}"]`
            );

            // Check if mouse is moving back to the trigger
            if (relatedTarget && trigger && (trigger === relatedTarget || trigger.contains(relatedTarget))) {
              return; // Don't close if moving back to trigger
            }

            // Close with delay
            this.hoverCloseTimer = setTimeout(() => {
              if (this.activeSubmenu === submenuHandle) {
                this.closeSubmenu();
              }
            }, 300);
          });
        });
      }

      // Add close button handlers for submenus (closes entire menu)
      this.submenus.forEach((submenu) => {
        const closeBtn = submenu.querySelector('.header-offcanvas-submenu__close');
        if (closeBtn) {
          closeBtn.addEventListener('click', () => {
            // Add closing class for slide animation when using close button
            submenu.classList.add('closing');
            setTimeout(() => {
              this.closeMenu();
              submenu.classList.remove('closing');
            }, 300);
          });
        }
      });

      // Add overlay click handlers
      this.overlays.forEach((overlay) => {
        overlay.addEventListener('click', () => {
          this.closeMenu();
        });
      });

      // Handle escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          if (this.activeSubmenu) {
            this.closeSubmenu();
          } else if (this.activeMenu) {
            this.closeMenu();
          }
        }
      });

      // Update desktop check on window resize
      window.addEventListener('resize', () => {
        this.isDesktop = window.matchMedia('(min-width: 990px)').matches;
      });
    }

    openMenu(handle) {
      // Close any open menu first
      this.closeMenu();

      // Set header position for proper placement
      const header = document.querySelector('.sleepdoctor-header-offcanvas.header-wrapper');
      if (header) {
        const headerBottom = header.getBoundingClientRect().bottom;
        document.documentElement.style.setProperty('--header-bottom-position-desktop', `${headerBottom}px`);
      }

      // Find and open the corresponding menu
      const menu = document.querySelector(`.header-offcanvas-menu[data-menu-handle="${handle}"]`);
      const overlay = document.querySelector(`.header-offcanvas-overlay[data-menu-handle="${handle}"]`);
      const trigger = document.querySelector(`.header-offcanvas-trigger[data-menu-handle="${handle}"]`);

      if (menu && overlay) {
        menu.setAttribute('aria-hidden', 'false');
        overlay.setAttribute('aria-hidden', 'false');
        trigger?.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        this.activeMenu = handle;

        // Focus management
        const firstFocusable = menu.querySelector('a, button');
        if (firstFocusable) {
          setTimeout(() => firstFocusable.focus(), 100);
        }
      }
    }

    openSubmenu(submenuHandle, parentMenu) {
      // Close any currently open submenu first
      if (this.activeSubmenu && this.activeSubmenu !== submenuHandle) {
        this.closeSubmenu();
      }

      const submenu = document.querySelector(
        `.header-offcanvas-submenu[data-submenu-handle="${submenuHandle}"][data-parent-menu="${parentMenu}"]`
      );
      const trigger = document.querySelector(
        `.header-offcanvas-menu__submenu-trigger[data-submenu-handle="${submenuHandle}"]`
      );
      const mainMenu = document.querySelector(`.header-offcanvas-menu[data-menu-handle="${parentMenu}"]`);

      if (submenu) {
        // If clicking the same submenu trigger, toggle it
        if (this.activeSubmenu === submenuHandle) {
          this.closeSubmenu();
          return;
        }

        submenu.setAttribute('aria-hidden', 'false');
        trigger?.setAttribute('aria-expanded', 'true');
        mainMenu?.classList.add('has-submenu-open');
        this.activeSubmenu = submenuHandle;
        this.activeSubmenuParent = parentMenu;

        // Focus management
        const firstFocusable = submenu.querySelector('a, button');
        if (firstFocusable) {
          setTimeout(() => firstFocusable.focus(), 100);
        }
      }
    }

    closeSubmenu() {
      if (!this.activeSubmenu) return;

      // Clear any pending hover timer
      clearTimeout(this.hoverCloseTimer);

      const submenu = document.querySelector(`.header-offcanvas-submenu[data-submenu-handle="${this.activeSubmenu}"]`);
      const trigger = document.querySelector(
        `.header-offcanvas-menu__submenu-trigger[data-submenu-handle="${this.activeSubmenu}"]`
      );
      const mainMenu = this.activeSubmenuParent
        ? document.querySelector(`.header-offcanvas-menu[data-menu-handle="${this.activeSubmenuParent}"]`)
        : null;

      if (submenu) {
        submenu.setAttribute('aria-hidden', 'true');
        trigger?.setAttribute('aria-expanded', 'false');
        mainMenu?.classList.remove('has-submenu-open');

        // Return focus to trigger only on keyboard navigation (not hover)
        if (!this.isDesktop && trigger) {
          trigger.focus();
        }

        this.activeSubmenu = null;
        this.activeSubmenuParent = null;
      }
    }

    closeMenu() {
      if (!this.activeMenu) return;

      // Clear any pending hover timer
      clearTimeout(this.hoverCloseTimer);

      // Close any open submenu first
      this.closeSubmenu();

      const menu = document.querySelector(`.header-offcanvas-menu[data-menu-handle="${this.activeMenu}"]`);
      const overlay = document.querySelector(`.header-offcanvas-overlay[data-menu-handle="${this.activeMenu}"]`);
      const trigger = document.querySelector(`.header-offcanvas-trigger[data-menu-handle="${this.activeMenu}"]`);

      if (menu && overlay) {
        menu.setAttribute('aria-hidden', 'true');
        overlay.setAttribute('aria-hidden', 'true');
        trigger?.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';

        // Return focus to trigger
        if (trigger) {
          trigger.focus();
        }

        this.activeMenu = null;
      }
    }
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      window.headerOffcanvasMenuInstance = new HeaderOffcanvasMenu();
    });
  } else {
    window.headerOffcanvasMenuInstance = new HeaderOffcanvasMenu();
  }

  // Close ALL navigation when predictive search is clicked
  document.addEventListener('click', function(e) {
    // Check if click is anywhere within .header__search
    if (e.target.closest('.header__search')) {
      // Force close ALL navigation elements
      document.querySelectorAll('.header-offcanvas-menu').forEach(menu => {
        menu.setAttribute('aria-hidden', 'true');
      });

      document.querySelectorAll('.header-offcanvas-overlay').forEach(overlay => {
        overlay.setAttribute('aria-hidden', 'true');
      });

      document.querySelectorAll('.header-offcanvas-submenu').forEach(submenu => {
        submenu.setAttribute('aria-hidden', 'true');
      });

      document.querySelectorAll('.header-offcanvas-trigger').forEach(trigger => {
        trigger.setAttribute('aria-expanded', 'false');
      });

      document.querySelectorAll('.header-offcanvas-menu__submenu-trigger').forEach(trigger => {
        trigger.setAttribute('aria-expanded', 'false');
      });

      // Clear instance state
      if (window.headerOffcanvasMenuInstance) {
        window.headerOffcanvasMenuInstance.activeMenu = null;
        window.headerOffcanvasMenuInstance.activeSubmenu = null;
      }

      document.body.style.overflow = '';
    }
  });

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  // customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleepdoctor-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      /* Sleepdoctor addition to core Dawn code */
      if (this.headerIsAlwaysSticky) {
        const announcementBar = document.querySelector('.announcement-bar-section');

        if (scrollTop > 0) {
          if (announcementBar) {
            announcementBar?.classList.add('sticky-announcement-bar');

            if (this.header && this.header.style.top !== `${announcementBar.clientHeight}px`) {
              this.header.style.top = `${announcementBar.clientHeight}px`;
            }
          }
        } else {
          if (announcementBar) {
            announcementBar?.classList.remove('sticky-announcement-bar');
          }
        }
      }
      /* End Sleepdoctor addition to core Dawn code */

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* Sleepdoctor custom JS */

  // Adding hover to supplement statndard Dawn theme click event for top level nav items
  document.querySelectorAll('.sleepdoctor-header .list-menu--inline > li').forEach((listItem) => {
    listItem.addEventListener('mouseenter', (event) => {
      document.querySelectorAll('.sleepdoctor-header header-menu details[open]').forEach((openDetail) => {
        openDetail.removeAttribute('open');
      });
      if (event.target.querySelector('details')) {
        event.target.querySelector('details').setAttribute('open', true);
      }
    });
  });

  document.querySelectorAll('.sleepdoctor-header .secondary-menu-wrapper, .sleepdoctor-header .mega-menu__list').forEach((listItem) => {
    listItem.addEventListener('mouseleave', (event) => {
      document.querySelectorAll('.sleepdoctor-header header-menu details[open]').forEach((openDetail) => {
        openDetail.removeAttribute('open');
      });
    });
  });
  
  // Hover event for primary megamenu layout subnav items
  document.querySelectorAll('.sleepdoctor-header [data-tab]').forEach((tabItem) => {
    tabItem.addEventListener('mouseenter', (event) => {
      tabItem
        .closest('.mega-menu__content')
        .querySelector('.sleepdoctor-header [data-tab].active')
        .classList.remove('active');
      tabItem
        .closest('.mega-menu__content')
        .querySelector('.sleepdoctor-header .tab-content.active')
        .classList.remove('active');
      tabItem
        .closest('.mega-menu__content')
        .querySelector('.sleepdoctor-header .featured-entities.active')
        .classList.remove('active');

      tabItem.classList.add('active');
      if (tabItem.closest('.mega-menu__content').querySelector(`#${tabItem.dataset.tab}`)) {
        tabItem.closest('.mega-menu__content').querySelector(`#${tabItem.dataset.tab}`).classList.add('active');
      }

      if (tabItem.closest('.mega-menu__content').querySelector(`[data-featured-articles="${tabItem.dataset.tab}"]`)) {
        tabItem
          .closest('.mega-menu__content')
          .querySelector(`[data-featured-articles="${tabItem.dataset.tab}"]`)
          .classList.add('active');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleepdoctor-hst-quiz"] && !Shopify.designMode) return;
  try {
    
  document
    .querySelector('.sleepdoctor-hst-quiz #pfq-submit')
    .addEventListener('click', function (o) {
      var t = document.querySelector('.sleepdoctor-hst-quiz');
      var e = t.querySelectorAll('select'),
        r = t.querySelector('#pfq-error-msg'),
        a = o.currentTarget.dataset.resultsLink,
        l = 'yes' == o.currentTarget.dataset.target ? '_blank' : '_self',
        n = [!1, !1, !1],
        s = 'yes' == o.currentTarget.dataset.customResults,
        i = Array.from(e).map(function (e) {
          var t = e.dataset.questionNum;
          return s && (n[t - 129] = e.value), 'false' != e.value && e.value;
        }),
        c = function e() {
          
        };
      if (
        i.some(function (e) {
          return !e;
        })
      )
        r.classList.remove('hide'),
          t.classList.add('has-error'),
          setTimeout(function () {
            r.classList.add('hide'), t.classList.remove('has-error');
          }, 3e3);
      else if (
        s &&
        n.every(function (e) {
          return !1 !== e;
        })
      ) {
        var d;
        (n = n.join('')),
          null === (d = pfqCustomResults) || void 0 === d
            ? void 0
            : d.forEach(function (e) {
                if (e.answer === n) return console.log(e.url), window.location.assign(e.url);
              }),
          c();
      } else c();
    });

  } catch(e) { console.error(e); }
})();
})();
